import React from 'react'
import PropTypes from 'prop-types'
import { Menu } from '@adc/ui-core'
import _ from 'lodash'
import classNames from 'classnames/bind'
import cls from '../styles.scss'
import { MENU_ITEM } from '../constants/classnames'
const cx = classNames.bind(cls)

const MenuItem = ({
  className,
  children,
  elmId,
  url,
  title,
  onClick,
  ...props
}) => (
  <Menu.Item
    href={url}
    link
    onClick={onClick}
    className={cx(className, MENU_ITEM)}
    data-elm-id={elmId}
    {...props}
  >
    {children || title}
  </Menu.Item>
)

MenuItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.node,
  elmId: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.node,
  onClick: PropTypes.func,
}

MenuItem.defaultProps = {
  onClick: _.noop,
}

export default MenuItem
